import { render, staticRenderFns } from "./BusinessSuiteList.vue?vue&type=template&id=48006c5d&scoped=true&"
import script from "./BusinessSuiteList.vue?vue&type=script&lang=js&"
export * from "./BusinessSuiteList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSuiteList.vue?vue&type=style&index=0&id=48006c5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48006c5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
